// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import { AuthProvider } from './contexts/AuthContext';
import { ArticleProvider } from './contexts/ArticleContext';

// Layout Components
import Header from './components/Header';
import FooterItem from './components/FooterItem';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Auth from './pages/Auth';
import Archive from './pages/Archive';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';
import EditPost from './pages/EditPost';
import NotFound from './pages/NotFound';

// Protected Route Component
import AuthGuard from './components/AuthGuard';

// 主题配置
const theme = {
  token: {
    colorPrimary: '#4361ee',
    borderRadius: 8,
    fontSize: 14,
  },
};

function App() {
  return (
    <ConfigProvider locale={zhCN} theme={theme}>
      <AuthProvider>
        <ArticleProvider>
          <Router>
            <div className="app">
              <Header />
              
              <main className="main-content">
                <Routes>
                  {/* 公开路由 */}
                  <Route path="/" element={<Home />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/archive" element={<Archive />} />
                  <Route path="/post/:id" element={<PostDetail />} />
                  
                  {/* 个人主页/关于页面 */}
                  <Route 
                    path="/about" 
                    element={
                      <AuthGuard>
                        <About />
                      </AuthGuard>
                    } 
                  />
                  
                  {/* 重定向 /profile 到 /about */}
                  <Route path="/profile" element={<Navigate to="/about" replace />} />
                  
                  {/* 需要登录的路由 */}
                  <Route 
                    path="/write" 
                    element={
                      <AuthGuard>
                        <WritePost />
                      </AuthGuard>
                    } 
                  />
                  <Route 
                    path="/edit/:id" 
                    element={
                      <AuthGuard>
                        <EditPost />
                      </AuthGuard>
                    } 
                  />
                  
                  {/* 404页面 */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              
              <FooterItem />
            </div>
          </Router>
        </ArticleProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;